// extracted by mini-css-extract-plugin
module.exports = {"field":"Details_field__17QlY"};